import { DEFAULT_STORE_OBJECT } from '../constants';
import type { DefaultStoreObject } from '../types';
import CarrierRegistrationTypes from './CarrierRegistrationTypes';

export interface CarrierRegistrationState {
  addEmail: DefaultStoreObject<null>;
  removeEmail: DefaultStoreObject<null>;
  registerEmail: DefaultStoreObject<unknown[]>;
}
const initialState: CarrierRegistrationState = {
  registerEmail: { ...DEFAULT_STORE_OBJECT, data: [] },
  addEmail: { ...DEFAULT_STORE_OBJECT },
  removeEmail: { ...DEFAULT_STORE_OBJECT },
};

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
const CarrierRegistrationReducer = (state = initialState, { type, payload }: any): CarrierRegistrationState => {
  switch (type) {
    case CarrierRegistrationTypes.REGISTER_EMAIL_PROGRESS: {
      return {
        ...state,
        addEmail: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case CarrierRegistrationTypes.REGISTER_EMAIL_SUCCESS: {
      return {
        ...state,
        addEmail: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
        },
      };
    }

    case CarrierRegistrationTypes.REGISTER_EMAIL_ERROR: {
      return {
        ...state,
        addEmail: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
        },
      };
    }
    case CarrierRegistrationTypes.GET_REGISTER_EMAIL_PROGRESS: {
      return {
        ...state,
        registerEmail: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: [],
        },
        addEmail: { ...DEFAULT_STORE_OBJECT },
        removeEmail: { ...DEFAULT_STORE_OBJECT },
      };
    }

    case CarrierRegistrationTypes.GET_REGISTER_EMAIL_SUCCESS: {
      return {
        ...state,
        registerEmail: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data || [],
        },
      };
    }

    case CarrierRegistrationTypes.GET_REGISTER_EMAIL_ERROR: {
      return {
        ...state,
        registerEmail: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: [],
        },
      };
    }
    case CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_PROGRESS: {
      return {
        ...state,
        removeEmail: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_SUCCESS: {
      return {
        ...state,
        removeEmail: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
        },
      };
    }

    case CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_ERROR: {
      return {
        ...state,
        removeEmail: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
        },
      };
    }
    default:
      return state;
  }
};

export default CarrierRegistrationReducer;
